import axios from 'axios';

const updateTicket = ({ id, ...params }) => {
  return axios.put(`tickets/ubidesk/${id}`, params);
};

const archiveTicket = id => axios.delete(`tickets/ubidesk/${id}`);

export { updateTicket, archiveTicket };
